import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Util from "../../util/Util";
import CustomLabel from "../sub/CustomLabel";
import { Card, CardHeader, CardBody } from "reactstrap";
import {
  checkIfUsernameExists,
  checkIfEmailExists,
} from "../../actions/user/user";
import { createUser, updateUser } from "../../actions/user/user";
import Roles from "../../enums/Roles";

class UserAddModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: null,
      first_name: null,
      name: null,
      email: null,
      password: null,
      role: "",

      //******** RIGHT ACCESS  ********/
      access_e4bizz: false,
      access_e4coll: false,

      access_e4mad: false,
      access_module_desk: false,

      access_e4vhp: false,

      usernameError: null,
      first_nameError: null,
      nameError: null,
      emailError: null,
      passwordError: null,
    };
    if (this.props.user) {
      this.state = {
        username: this.props.user.username,
        name: this.props.user.name,
        first_name: this.props.user.first_name,
        email: this.props.user.email,
        company_id: this.props.company._id,
        password: "*********",
        role: this.props.user.role,

        access_e4bizz:
          this.props.user.access_e4coll === true &&
          this.props.user.access_e4mad === true &&
          this.props.user.access_e4vhp === true
            ? true
            : false,
        access_e4coll: this.props.user.access_e4coll,

        access_e4mad: this.props.user.access_e4mad,
        access_module_desk: this.props.user.access_module_desk,

        access_e4vhp: this.props.user.access_e4vhp,
      };
    }
  }

  stopEvent(e) {
    e.stopPropagation();
  }

  lookForChange() {
    if (
      this.state.name === this.props.user.name &&
      this.state.first_name === this.props.user.first_name &&
      this.state.username === this.props.user.username &&
      this.state.email === this.props.user.email &&
      this.state.role === this.props.user.role &&
      this.state.password === "*********" &&
      this.state.access_e4coll === this.props.user.access_e4coll &&
      this.state.access_e4mad === this.props.user.access_e4mad &&
      this.state.access_module_desk === this.props.user.access_module_desk &&
      this.state.access_e4vhp === this.props.user.access_e4vhp
    ) {
      return false;
    } else {
      return true;
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    e.stopPropagation();

    // No previous error
    if (this.hasError()) return;

    if (!this.props.user) {
      var data = {
        user: {
          username: this.state.username,
          name: this.state.name,
          first_name: this.state.first_name,
          email: this.state.email,
          role: this.state.role,
          company_id: this.props.company._id,
          password: this.state.password,
          access_e4coll: this.state.access_e4coll,
          access_e4mad: this.state.access_e4mad,
          access_module_desk: this.state.access_module_desk,
          access_e4vhp: this.state.access_e4vhp,
        },
      };

      // Send login information and redirect on success
      this.props.onCreateUser(
        data,
        () => this.props.close(),
        (e) => console.log(e),
      );
    } else {
      data = {
        user: {
          _id: this.props.user._id,
          username: this.state.username,
          name: this.state.name,
          first_name: this.state.first_name,
          email: this.state.email,
          role: this.state.role,
          company_id: this.props.company._id,
          password:
            this.state.password !== "*********" ? this.state.password : null,
          access_e4coll: this.state.access_e4coll,
          access_e4mad: this.state.access_e4mad,
          access_module_desk: this.state.access_module_desk,
          access_e4vhp: this.state.access_e4vhp,
          mad_theme: "E4MAD",
        },
      };

      this.lookForChange() &&
        this.props.onUpdateUser(
          data,
          () => this.props.close(),
          (e) => console.log(e),
        );
    }
  }

  hasEmptyField() {
    return (
      !this.state.username ||
      !this.state.first_name ||
      !this.state.name ||
      !this.state.email ||
      !this.state.password
    );
  }

  hasError() {
    return (
      this.state.usernameError ||
      this.state.first_nameError ||
      this.state.nameError ||
      this.state.emailError ||
      this.state.passwordError
    );
  }

  onChange(field, value) {
    this.setState({ [field]: value });

    if (field === "access_e4bizz" && this.state.access_e4bizz === false) {
      this.setState({
        access_e4coll: true,
        access_e4vhp: true,
      });
    } else if (field === "access_e4bizz" && this.state.access_e4bizz === true) {
      this.setState({
        access_e4coll: false,
        access_e4vhp: false,
      });
    }
    if (
      (field === "access_e4coll" || field === "access_e4vhp") &&
      this.state.access_e4bizz === true
    ) {
      this.setState({ access_e4bizz: false });
    }

    if (field === "access_e4mad" && value === false) {
      this.setState({ access_module_desk: false });
    }

    if (field === "access_module_desk" && value === true) {
      this.setState({ access_e4mad: true });
    }

    // Check if username is not empty and not already taken
    if (field === "username" && !Util.emptyString(value)) {
      this.setState({ usernameError: null });
      this.props.onCheckIfUsernameExists(value, this.props.company._id, () => {
        this.setState({
          usernameError: <FormattedMessage id="Username.Already.Exists" />,
        });
      });
    }
  }

  update(field) {
    if (this.disabled() || !this.isUpdate()) return;

    if (
      this.isUpdate() &&
      field === "email" &&
      this.props.collaborator.email === this.state[field]
    )
      return;

    if (
      this.isUpdate() &&
      field === "username" &&
      this.props.collaborator.username === this.state[field]
    )
      return;

    this.props.onUpdateCollaborator({
      collaboratorId: this.props.collaborator._id,
      updatedField: field,
      updatedValue: this.state[field],
    });
  }

  getRoleOptions() {
    const adminUser = this.props.users.filter((u) => u.role === Roles.ADMIN);

    let options = [];

    for (const r in Roles) {
      if (
        parseInt(Roles[r]) === parseInt(Roles.SUPER_ADMIN) ||
        (this.props.user?.role !== Roles.CLIENT &&
          parseInt(Roles[r]) === parseInt(Roles.CLIENT))
      )
        continue;

      options.push(
        <option
          key={r}
          value={Roles[r]}
          disabled={Roles[r] === Roles.ADMIN && adminUser?.length >= 1}
        >
          {this.props.intl.formatMessage({
            id: "Role." + Roles[r],
          })}
        </option>,
      );
    }

    return options;
  }

  render() {
    return (
      <div className="modal-bg show">
        <div className="modal fade show">
          <div
            className="modal-dialog modal-lg"
            role="document"
            onClick={(e) => this.stopEvent(e)}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {!this.props.user ? (
                    <FormattedMessage id="Add.User" />
                  ) : (
                    <FormattedMessage id="Edit.User" />
                  )}
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => this.props.close()}
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form onSubmit={(e) => this.handleSubmit(e)} autoComplete="off">
                  <div className="form-group">
                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="Company.Name" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          id="company"
                          name="company"
                          className="form-control"
                          value={this.props.company.name}
                          disabled={true}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="First.Name" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          id="first_name"
                          name="first_name"
                          className="form-control"
                          placeholder={this.props.intl.formatMessage({
                            id: "First.Name",
                          })}
                          defaultValue={this.state.first_name}
                          onChange={(e) =>
                            this.onChange("first_name", e.target.value)
                          }
                        />
                        <small className="text-danger">
                          {this.state.first_nameError}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="Name" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          id="name"
                          name="name"
                          className="form-control"
                          placeholder={this.props.intl.formatMessage({
                            id: "Name",
                          })}
                          defaultValue={this.state.name}
                          onChange={(e) =>
                            this.onChange("name", e.target.value)
                          }
                        />
                        <small className="text-danger">
                          {this.state.nameError}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="role" className="col-form-label">
                          <FormattedMessage id="Role" />
                        </label>
                      </div>
                      <div className="col-7">
                        <select
                          id="role"
                          className={"form-control"}
                          disabled={this.props.user?.role === Roles.CLIENT}
                          onChange={(e) =>
                            this.props.user?.role !== Roles.CLIENT &&
                            this.onChange("role", e.target.value)
                          }
                          defaultValue={this.state.role}
                        >
                          <option key="" value="">
                            {this.props.intl.formatMessage({
                              id: "Select",
                            })}
                          </option>
                          {this.getRoleOptions()}
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="Username" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          id="username"
                          name="username"
                          className="form-control"
                          autoComplete="off"
                          placeholder={this.props.intl.formatMessage({
                            id: "Username",
                          })}
                          defaultValue={this.state.username}
                          onChange={(e) =>
                            this.onChange("username", e.target.value)
                          }
                        />
                        <small className="text-danger">
                          {this.state.usernameError}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="Email" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="text"
                          id="email"
                          name="email"
                          className="form-control"
                          autoComplete="off"
                          placeholder={this.props.intl.formatMessage({
                            id: "Email",
                          })}
                          defaultValue={this.state.email}
                          onChange={(e) =>
                            this.onChange("email", e.target.value)
                          }
                        />
                        <small className="text-danger">
                          {this.state.emailError}
                        </small>
                      </div>
                    </div>

                    <div className="form-group row mb-5">
                      <div className="col">
                        <label htmlFor="date" className="col-form-label">
                          <FormattedMessage id="Password" />
                        </label>
                      </div>
                      <div className="col-7">
                        <input
                          type="password"
                          className="form-control"
                          placeholder={this.props.intl.formatMessage({
                            id: "Password",
                          })}
                          defaultValue={this.state.password}
                          autoComplete="off"
                          onChange={(e) =>
                            this.onChange("password", e.target.value)
                          }
                        />
                        <small className="text-danger">
                          {this.state.passwordError}
                        </small>
                      </div>
                    </div>

                    <div className="mb-3 mt-3">
                      <p>
                        <b>
                          <FormattedMessage id="Access.Rights" />
                        </b>
                      </p>
                    </div>
                    <Card>
                      <CardHeader>
                        <div className="row">
                          <div className="col">
                            <CustomLabel
                              label={this.props.intl.formatMessage({
                                id: "Access.E4BIZZ",
                              })}
                              htmlFor="access_e4bizz"
                              labelClassName="col-11"
                            />
                          </div>
                          <div className="form-check col-1">
                            <input
                              className="form-check-input"
                              id="access_e4bizz"
                              checked={this.state.access_e4bizz}
                              onChange={(e) =>
                                this.onChange("access_e4bizz", e.target.checked)
                              }
                              type="checkbox"
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div className="row">
                          <div className="col">
                            <CustomLabel
                              label={this.props.intl.formatMessage({
                                id: "Access.E4COLL",
                              })}
                              htmlFor="access_e4col"
                              labelClassName="col-11"
                            />
                          </div>
                          <div className="form-check col-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="access_e4coll"
                              checked={this.state.access_e4coll}
                              onChange={(e) =>
                                this.onChange("access_e4coll", e.target.checked)
                              }
                            />
                          </div>
                        </div>
                        <div className="row">
                          <div className="col">
                            <CustomLabel
                              label={this.props.intl.formatMessage({
                                id: "Access.E4VHP",
                              })}
                              htmlFor="access_e4vhp"
                              labelClassName="col-11"
                            />
                          </div>
                          <div className="form-check col-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="access_e4vhp"
                              checked={this.state.access_e4vhp}
                              onChange={(e) =>
                                this.onChange(
                                  "access_e4vhp",
                                  !this.state.access_e4vhp,
                                )
                              }
                            />
                          </div>
                        </div>
                      </CardBody>
                    </Card>

                    <Card className="mt-4">
                      <CardHeader>
                        <div className="row">
                          <div className="col">
                            <CustomLabel
                              label={this.props.intl.formatMessage({
                                id: "Access.E4MAD",
                              })}
                              htmlFor={"access_e4mad"}
                              labelClassName="col-11"
                            />
                            {/* <FormattedMessage id="Access.E4BIZZ" /> */}
                          </div>
                          <div className="form-check col-1">
                            <input
                              className="form-check-input"
                              id={"access_e4mad"}
                              checked={this.state.access_e4mad}
                              onChange={(e) =>
                                this.onChange(
                                  "access_e4mad",
                                  !this.state.access_e4mad,
                                )
                              }
                              type="checkbox"
                            />
                          </div>
                        </div>
                      </CardHeader>
                      <CardBody>
                        <div className="row">
                          <div className="col">
                            <CustomLabel
                              label={this.props.intl.formatMessage({
                                id: "Access.E4MAG",
                              })}
                              htmlFor="access_module_desk"
                              labelClassName="col-11"
                            />
                          </div>
                          <div className="form-check col-1">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              id="access_module_desk"
                              checked={this.state.access_module_desk}
                              onChange={(e) =>
                                this.onChange(
                                  "access_module_desk",
                                  !this.state.access_module_desk,
                                )
                              }
                            />
                          </div>
                        </div>
                      </CardBody>
                    </Card>
                  </div>

                  <div className="row mt-4">
                    <div className="col-4 m-auto">
                      <button
                        type="submit"
                        disabled={
                          !this.props.user
                            ? this.hasEmptyField()
                            : !this.lookForChange()
                        }
                        className="btn btn-info btn-block button-info right"
                      >
                        {!this.props.user ? (
                          <FormattedMessage id="Create" />
                        ) : (
                          <FormattedMessage id="Update" />
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCheckIfUsernameExists: (username, existsCallback, noExistsCallback) =>
      dispatch(
        checkIfUsernameExists(username, existsCallback, noExistsCallback),
      ),
    onCheckIfEmailExists: (
      email,
      company_id,
      existsCallback,
      noExistsCallback,
    ) =>
      dispatch(
        checkIfEmailExists(email, company_id, existsCallback, noExistsCallback),
      ),
    onCreateUser: (data, successCallback, failureCallback) =>
      dispatch(createUser(data, successCallback, failureCallback)),
    onUpdateUser: (data, successCallback, failureCallback) =>
      dispatch(updateUser(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(UserAddModal));
